@if (previewCard()) {
  <div
    class="preview {{ previewCard().class }}"
    (click)="onClick()">
    <div
      class="preview-card {{ previewCard().class }}"
      [ngStyle]="{ 'background-image': backgroundImage }"></div>
    <div class="preview-shadow"></div>
    <div class="preview-text">
      <p>{{ previewCard().title | truncateWords: 16 }}</p>
    </div>
  </div>
}
